import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
// Use dynamic API URL based on current origin for production compatibility
const getApiUrl = () => {
  // In production, use same origin. In development, use env variable.
  if (process.env.NODE_ENV === 'production') {
    return `${window.location.origin}/api`;
  }
  return `${process.env.REACT_APP_BACKEND_URL}/api`;
};

export default function AuthCallback() {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      const hash = window.location.hash;
      const sessionIdMatch = hash.match(/session_id=([^&]+)/);
      
      if (!sessionIdMatch) {
        console.error('No session_id found in URL hash');
        navigate('/');
        return;
      }

      const sessionId = sessionIdMatch[1];
      const API = getApiUrl();

      try {
        console.log('Exchanging session_id for token...');
        const response = await fetch(`${API}/auth/session`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          credentials: 'include',
          body: JSON.stringify({ session_id: sessionId }),
        });

        if (!response.ok) {
          const errorText = await response.text();
          console.error('Session exchange failed:', response.status, errorText);
          throw new Error('Failed to create session');
        }

        const userData = await response.json();
        console.log('Auth successful, redirecting to dashboard...');
        
        // Clear the hash from URL
        window.history.replaceState(null, '', window.location.pathname);
        
        // Navigate to dashboard with user data
        navigate('/dashboard', { state: { user: userData }, replace: true });
      } catch (error) {
        console.error('Auth error:', error);
        navigate('/');
      }
    };

    processAuth();
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FAFAFA]">
      <div className="text-center">
        <div className="w-16 h-16 border-4 border-[#F3C9CF] border-t-[#B3121B] rounded-full animate-spin mx-auto mb-4"></div>
        <p className="text-[#6E0F1A] font-serif text-xl">Autenticando...</p>
      </div>
    </div>
  );
}
